import React from "react";
import {connect} from 'react-redux';
import find from "lodash/find";
import {IonAlert} from "@ionic/react";
import {useTranslation} from 'react-i18next';

import {shopsSelectShop} from "../../actions/Shops";

function AlertSelectShop(
    {
        // props
        state,
        setState,
        callbackFunction = () => {},

        // state
        shops,

        // action
        shopsSelectShop,
    }
) {
    const {t} = useTranslation();

    const checkedShops = (id, index) => {
        const pathShopId = localStorage.getItem('activeShop');
        if (pathShopId) {
            return id == pathShopId;
        }
        return index == 0;
    }

    const listInputsShops = shops ? shops.map((val, i) => ({
        label: val.trade_name,
        type: 'radio',
        value: val.id,
        checked: checkedShops(val.id, i),
    })) : [];

    return <IonAlert
                mode="ios"
                className="alert-select-shop"
                isOpen={state}
                onDidDismiss={(val) => {
                    setState(false);
                    if(val.detail.role === 'backdrop') {
                        callbackFunction();
                    }
                }}
                header={t('alertSelectShop.header', "Choose which account you want to enter")}
                buttons={[
                    {
                        text: t('alertSelectShop.button', "OK"),
                        role: 'confirm',
                        handler: (value) => {
                            const selectedShop = find(shops, {id: value});
                            shopsSelectShop(selectedShop);
                        },
                    }
                ]}
                inputs={listInputsShops}
            />
}


const mapStateToProps = state => ({
    shops: state.Shops.shops,
});

const mapDispatchToProps = dispatch => ({
    shopsSelectShop: shop => dispatch(shopsSelectShop(shop)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AlertSelectShop);